import { calculateActivationTotalForProduct } from './calculateActivationTotalForProduct.mjs'
// Takes the activationDate and nextInvoiceDate, whether the quote is a difference quote or not, the number of months prepaid, and all of the monthly product MonthlyPrice objects
// adds the proratedPrice property to the monthlyPrice objects which is the price prorated for the number of days
// returns the total amount due at activation for the monthly products (Does not include onetime products or payroll)
export function calculateMonthlyTotalForActivation(
   //MonthlyPrice objects for each monthly product which factors into the activation total
   productCoreMonthlyCosts,
   productPerformanceMonthlyCosts,
   productTimeTrackingMonthlyCosts,
   productTimeAttendanceMonthlyCosts,
   productBenefitsAdministrationMonthlyCosts,
   AdditionalJobsCosts,
   AdditionalStorageCosts,
   TestAccountCosts,
   MonthlyTaxCosts,
   TimeClockMonthlyCost,
   MonthlyDynamicCosts,
   // Required inputs to perform a calculation.
   product_list,
   discount_list,
   book_id,
   quoteType,
   coreProductSelected,
   productCoreEECount,
   productPerformanceEECount,
   productTimeTrackingEECount,
   hasTimeClocks,
   productTimeClockDetails,
   productBenefitsAdministrationEECount,
   productPayrollEINCount,
   productPayrollEECount,
   productPayrollEECounts,
   productPayrollTotalStateCount,
   productPayrollStateCounts,
   professionalServiceDetails,
   consultingServiceDetails,
   impType,
   benAdminImpType,
   payrollImpType,
   discountBundle,
   discountNonProfit,
   prepayLength,
   discountMultiEntity,
   discountHRMonthlyPromotion,
   discountHRDealDeskMonthly,
   discountReseller,
   discountQuickstartTraining,
   discountImpPromotion,
   discountDealDeskHRImp,
   discountDealDeskPayrollImp,
   discountSecondEIN,
   discountGroupImp,
   discountDealDeskHRImpRate,
   discountDealDeskQuickstartImpRate,
   discountDealDeskPayrollImpRate,
   productAdditionalStorageCount,
   productAdditionalJobsCount,
   productHistoricalDataImport,
   productMarketplaceListing,
   productSponsorship,
   productPaidServiceAmount,
   productTestAccount,
   activationDate, // if not supplied, defaults to 1st day of month
   differenceQuote,
   accountSnowflake,
   coreCountryCount,
   promotionalDiscounts,
   nextInvoiceDate,
   currencyObject,
   accountBalance,
   monthlyTax,
   productEINIntegrations,
   allPermissions,
   user_role,
   account_status,
   pricebookDetails,
   previousCurrencyObject,
   productPayrollEINImpTypes,
   prepaymentActivationUseDifference,
   dynamicProducts,
   selectedTimeProduct = 'timeTracking',
   isATSOnly = false,
   isRecalculation = false,
   monthsToCalculate = null,
) {
   //Create a Tuple of all the parameters to pass to the calculateQuote function
   // This is a workaround to avoid passing too many parameters directly.
   const calculateParams = [
      product_list,
      discount_list,
      book_id,
      quoteType,
      coreProductSelected,
      productCoreEECount,
      productPerformanceEECount,
      productTimeTrackingEECount,
      hasTimeClocks,
      productTimeClockDetails,
      productBenefitsAdministrationEECount,
      productPayrollEINCount,
      productPayrollEECount,
      productPayrollEECounts,
      productPayrollTotalStateCount,
      productPayrollStateCounts,
      professionalServiceDetails,
      consultingServiceDetails,
      impType,
      benAdminImpType,
      payrollImpType,
      discountBundle,
      discountNonProfit,
      prepayLength,
      discountMultiEntity,
      discountHRMonthlyPromotion,
      discountHRDealDeskMonthly,
      discountReseller,
      discountQuickstartTraining,
      discountImpPromotion,
      discountDealDeskHRImp,
      discountDealDeskPayrollImp,
      discountSecondEIN,
      discountGroupImp,
      discountDealDeskHRImpRate,
      discountDealDeskQuickstartImpRate,
      discountDealDeskPayrollImpRate,
      productAdditionalStorageCount,
      productAdditionalJobsCount,
      productHistoricalDataImport,
      productMarketplaceListing,
      productSponsorship,
      productPaidServiceAmount,
      productTestAccount,
      activationDate, // if not supplied, defaults to 1st day of month
      differenceQuote,
      accountSnowflake,
      coreCountryCount,
      promotionalDiscounts,
      nextInvoiceDate,
      currencyObject,
      accountBalance,
      monthlyTax,
      productEINIntegrations,
      allPermissions,
      user_role,
      account_status,
      pricebookDetails,
      previousCurrencyObject,
      productPayrollEINImpTypes,
      prepaymentActivationUseDifference,
      dynamicProducts,
      selectedTimeProduct,
      isATSOnly,
   ]

   let monthlyProducts = [
      productCoreMonthlyCosts,
      productPerformanceMonthlyCosts,
      productTimeTrackingMonthlyCosts,
      productTimeAttendanceMonthlyCosts,
      productBenefitsAdministrationMonthlyCosts,
      AdditionalJobsCosts,
      AdditionalStorageCosts,
      TestAccountCosts,
      MonthlyTaxCosts,
      TimeClockMonthlyCost,
   ]
   MonthlyDynamicCosts.forEach((product) => {
      if (product_list[product.productCode]?.IncludeInActivation) {
         monthlyProducts.push(product)
      }
   })

   let ActivationMonthlyTotal = 0
   if (!isRecalculation) {
      for (const monthlyProduct of monthlyProducts) {
         let productActivationTotal = calculateActivationTotalForProduct(
            monthlyProduct,
            // Required inputs to perform a calculation.
            ...calculateParams,
            monthsToCalculate,
         )
         ActivationMonthlyTotal += productActivationTotal
      }
   } else {
      ActivationMonthlyTotal = 0
   }
   return ActivationMonthlyTotal
}
